import React, {Component} from "react";
import {RESOURCE_BASE_URL, ITEM_COUNT_PER_PAGE} from "../../../../configuration";
import AllAdminHeader from "../AllAdminHeader/AllAdminHeader";
import AllAdminRow from "../AllAdminRow/AllAdminRow";
import AllAdminBottom from "../AllAdminBottom/AllAdminBottom";
import axios from "axios";
import AllCustomersBottom from "../../AllCustomers/AllCustomersBottom/AllCustomersBottom";

class AllAdminTable extends Component{

    render() {

        let no = 1 + ((this.props.activePage - 1) * ITEM_COUNT_PER_PAGE);

        return (
            <div>
                <div className="admin-tables">
                    <div className="admin-table-row-content">
                        {/*<table className="table table-bordered customers-table-resp"></table>*/}
                        <table className="table table-bordered admins-table-resp">
                            <AllAdminHeader/>

                           <tbody>
                           {this.props.admins.length !== 0 ?
                               this.props.admins.map(admin => {
                                   return <AllAdminRow key={admin.id} no={no++} getAllAdmins={this.props.getAllAdmins} adminList={admin} userId = {this.props.userId}/>;
                               }) :

                               <tr><td colSpan={5}>
                                   利用できる管理者はいません。
                               </td></tr>
                           }
                           </tbody>
                        </table>

                    </div>
                </div>

                <AllAdminBottom activePage={this.props.activePage}
                                itemsCountPerPage={ITEM_COUNT_PER_PAGE}
                                totalItemsCount={this.props.totalItemCount}
                                handlePageChange={this.props.handlePageChange}
                                searching = {this.props.searching}/>

            </div>
        )
    }
}
export default AllAdminTable;



// WEBPACK FOOTER //
// ./src/components/Admin/AllAdminUsers/AllAdminTable/AllAdminTable.js